import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PanelService {

  serverUrl = environment.serverUrl;

  constructor(private http: HttpClient) { }

  getPanelUsers(params : any) {
    return this.http.get(`${this.serverUrl}/users`, { params : params });
  }

  addPanelUser(data) {
    return this.http.post(`${this.serverUrl}/user`, data);
  }

  getPanelUser(id) {
    return this.http.get(`${this.serverUrl}/user/${id}`)
  }

  editPanelUser(data, id) {
    return this.http.put(`${this.serverUrl}/user/${id}`, data);
  }

  deletePanelUser(id) {
    return this.http.delete(`${this.serverUrl}/user/${id}`);
  }

  // userMe(id) {
  //   return this.http.get(`${this.serverUrl}/user/me`, {user_id: id});
  // }
}
